<template>
  <section class="page">
    <h2 class="page-title">
      سایت های مرتبط با {{ route.params.keyword.replaceAll("_", " ") }}:
    </h2>
    <div
      class="gap-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4"
    >
      <div class="card mb-5" v-for="item in dataItems" :key="item">
        <div class="card-image">
          <img :alt="item.title" :src="item.logo" class="w-full rounded" />
        </div>
        <div class="card-body">
          <h3 class="card-title">{{ item.title }}</h3>
          <RouterLink
            class="text-link is-stretched"
            :to="{ name: 'urlDetails', params: { url: item.url } }"
            >مشاهده سایت</RouterLink
          >
        </div>
      </div>
    </div>

    <PaginationComp
      :totalItems="pagination.total"
      @set-pagination="changePagination"
    />
  </section>
</template>
<script setup>
import { ref, watch } from "vue";
import PaginationComp from "@/components/PaginationComp.vue";
import { useRoute } from "vue-router";
import axios from "axios";
const route = useRoute();

const dataItems = ref([]);
const pageLoad = ref(false);

const pagination = ref({
  total: 1,
  pageSize: 10,
  pageIndex: 1,
  searchKey: null,
});

function getDataItems() {
  pageLoad.value = true;
  axios({
    method: "GET",
    url: `/Site`,
    crossdomain: true,
    params: {
      SearchKey: route.params.keyword,
      pageSize: pagination.value.pageSize,
      pageIndex: pagination.value.pageIndex,
    },
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json; charset=utf-8",
      "access-control-allow-origin": "*",
    },
  })
    .then((res) => {
      dataItems.value = res.data.data;
      pagination.value.total = res.data.totalItem;

      document.title = `${process.env.VUE_APP_TITLE} - ${res.data.message[0]}`;
      document.getElementsByTagName("meta")["description"].content =
        res.data.message[0];
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(function () {
      pageLoad.value = false;
    });
}

function changePagination(p) {
  pagination.value.pageIndex = p.pageIndex;
  pagination.value.pageSize = p.pageSize;
  pagination.value.searchKey = p.searchKey;
  getDataItems();
}

watch(
  () => route.params.keyword,
  () => {
    getDataItems();
    const elmnt = document.getElementById("topScroll");
    window.scroll({
      top: elmnt.offsetTop + elmnt.offsetHeight,
      behavior: "smooth",
    });
  }
);
</script>
